import React from "react";
import { createRoot } from "react-dom/client";
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, devBypass, identityConfigured } from "./lib/auth.js";
import { devIdentity } from "./lib/api.js";
import App from "./App.jsx";
import "./styles.css";

async function boot() {
  const root = createRoot(document.getElementById("root"));
  if (devBypass) {
    root.render(<App account={{ name: `Dev Rep ${devIdentity.user}`, username: `dev.rep.${devIdentity.user}@liparifoods.com` }} />);
    return;
  }
  if (!identityConfigured) {
    root.render(<App notConfigured />);
    return;
  }
  await msalInstance.initialize();
  const result = await msalInstance.handleRedirectPromise();
  if (result?.account) msalInstance.setActiveAccount(result.account);
  else if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length) msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>,
  );
}
boot();
